export default [
  {
    PrimaryColor: '#0A8FDC',
    SecondaryColor: '#F04F47',
    SidebarColor: '#313541',
  },
  {
    PrimaryColor: '#905EAE',
    SecondaryColor: '#2D755A',
    SidebarColor: '#313541',
  },
  {
    PrimaryColor: '#266BB0',
    SecondaryColor: '#587527',
    SidebarColor: '#313541',
  },
  {
    PrimaryColor: '#F0464D',
    SecondaryColor: '#00B6EF',
    SidebarColor: '#313541',
  },
  {
    PrimaryColor: '#639F52',
    SecondaryColor: '#7C4D30',
    SidebarColor: '#313541',
  },
  {
    PrimaryColor: '#FFD955',
    SecondaryColor: '#C4476D',
    SidebarColor: '#313541',
  },

  {
    PrimaryColor: '#FD933A',
    SecondaryColor: '#5A63C8',
    SidebarColor: '#313541',
  },
  {
    PrimaryColor: '#03A9F4',
    SecondaryColor: '#FFC107',
    SidebarColor: '#313541',
  },
  {
    PrimaryColor: '#03A9F4',
    SecondaryColor: '#FF80AB',
    SidebarColor: '#313541',
  },

  {
    PrimaryColor: '#3F51B5',
    SecondaryColor: '#2196F3',
    SidebarColor: '#FFC107',
  },

  {
    PrimaryColor: '#9C27B0',
    SecondaryColor: '#FFCA28',
    SidebarColor: '#313541',
  },

  {
    PrimaryColor: '#673AB7',
    SecondaryColor: '#2196F3',
    SidebarColor: '#313541',
  },

  {
    PrimaryColor: '#F44336',
    SecondaryColor: '#FFA726',
    SidebarColor: '#313541',
  },

  {
    PrimaryColor: '#FF5722',
    SecondaryColor: '#3F51B5',
    SidebarColor: '#313541',
  },

  {
    PrimaryColor: '#FF9800',
    SecondaryColor: '#29B6F6',
    SidebarColor: '#313541',
  },

  {
    PrimaryColor: '#CDDC39',
    SecondaryColor: '#009688',
    SidebarColor: '#313541',
  },
  {
    PrimaryColor: '#8BC34A',
    SecondaryColor: '#FF8A65',
    SidebarColor: '#313541',
  },
  {
    PrimaryColor: '#4CAF50',
    SecondaryColor: '#FFC107',
    SidebarColor: '#313541',
  },
  {
    PrimaryColor: '#009688',
    SecondaryColor: '#4DD0E1',
    SidebarColor: '#313541',
  },
  {
    PrimaryColor: '#009688',
    SecondaryColor: '#0f7d5b',
    SidebarColor: '#313541',
  },
  {
    PrimaryColor: '#607D8B',
    SecondaryColor: '#FDD835',
    SidebarColor: '#313541',
  },
  {
    PrimaryColor: '#607D8B',
    SecondaryColor: '#F06292',
    SidebarColor: '#313541',
  },
  {
    PrimaryColor: '#795548',
    SecondaryColor: '#FFCA28',
    SidebarColor: '#313541',
  },
  {
    PrimaryColor: '#795548',
    SecondaryColor: '#4CAF50',
    SidebarColor: '#313541',
  },
];
